import React from 'react'
import { Button, Col, DatePicker, Row, Typography } from "antd";
import reportstyle from './ReportStyle/style';
import filter from "../../../src/assets/Images/filter.png";

const { Title } = Typography;

const UserReport = () => {
  return (
    <div>
      <Title level={3}>User Report</Title>
      <Row gutter={16}>
        <Col sm={24} md={12} lg={12}>
          <div>
            <div>
              <div>
                <Title className="client_totle_count" level={3}>
                  Total: 
                </Title>
              </div>
            </div>
          </div>
        </Col>
        <Col lg={12}>
          <Row className="" gutter={12}>
            <Col sm={24} md={4} lg={16}>
              <div className="client_filter_action_conatiner">
                <div style={reportstyle.filterstyle}>
                  <img
                    src={filter}
                    alt="filter"
                    style={reportstyle.imagestyle}
                  />
                  <input
                    type="text"
                    placeholder="Product name"
                    style={reportstyle.inputstyle}
                  />
                </div>
              </div>
            </Col>
            <Col sm={24} md={4} lg={8}>
              <div className="addclient_button">
                <div>
                  <DatePicker
                    type="text"
                    placeholder="Select Month"
                    style={reportstyle.datestyle}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default UserReport
